"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GET_DECODERS_QUERY = "\nquery{\n  user {\n    decoders{\n      id\n      name\n      recordCapable\n    }\n  }\n}\n";
exports.default = GET_DECODERS_QUERY;
//# sourceMappingURL=getDecoders.js.map